// The request model use for get usages on inventory page
export const REQUEST_RI_FILTER_DATA_MODEL = {
  'companyId': 1,
  'siteCode': 'BESPIN',
  'userEmail': 'string',
  'userId': 'string',
  'userName': 'string',
  'vendor': 'string',
  'startDate' : '202001',
  'endDate' : '202007'
};

export const REQUEST_RI_LIST_MODEL = {
  'companyId': 1,
  'siteCode': 'BESPIN',
  'sbscIds': [],
  'term': 'P1Y',
  'lbkPd': 'Last7Days',
  'sortField' : '',
  'start' : 1,
  'limit' : 10,
};



// WEBPACK FOOTER //
// ./src/constants/azure-reserved/azureRianalysisConstants.js